import React from 'react'


export const initialState = {
    terminals: []
};

export default React.createContext(initialState);